export const BookingEndpoint = {
    bookings: `${process.env.API_BACKEND}/v1/bookings/order/booking/`,
    nomenclature: `${process.env.API_BACKEND}/v1/bookings/order/booking/nomenclature/`,
    nomenclatureWithoutBackSlash: `${process.env.API_BACKEND}/v1/bookings/order/booking/nomenclature`,
    ahead: `${process.env.API_BACKEND}/v1/bookings/order/booking/ahead/`,
} as const
